"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordInput = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _UserValidator = require("../../validators/UserValidator/UserValidator");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledTooltip = (0, _styledComponents["default"])(_reactstrap.Tooltip)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .tooltip-inner {\n    text-align: left;\n    font-size: 12px;\n    max-width: 245px;\n\n    .icon-spacer {\n      width: 16px;\n      display: inline-block;\n      text-align: center;\n    }\n  }\n"])));

/**
 * Password Input Component
 */
var PasswordInput = exports.PasswordInput = /*#__PURE__*/function (_Component) {
  function PasswordInput(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PasswordInput);
    _this = _callSuper(this, PasswordInput, [props]);
    _this.state = {
      showTip: false,
      touched: false,
      tooltipValidation: _UserValidator.UserValidator.getPasswordTooltipValidation(props.value || '')
    };
    _this._handleChange = _this._handleChange.bind(_this);
    _this._invalid = _this._invalid.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(PasswordInput, _Component);
  return (0, _createClass2["default"])(PasswordInput, [{
    key: "_handleChange",
    value: function _handleChange(e) {
      var value = e.target.value;
      this.setState({
        touched: true,
        tooltipValidation: _UserValidator.UserValidator.getPasswordTooltipValidation(value)
      });
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        value = _this$props.value,
        defaultValue = _this$props.defaultValue,
        label = _this$props.label,
        placeholder = _this$props.placeholder,
        autoComplete = _this$props.autoComplete;
      return /*#__PURE__*/_react["default"].createElement("div", null, this._getTooltipNode(), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
        onChange: this._handleChange,
        className: className,
        value: value,
        defaultValue: defaultValue,
        label: label,
        autoComplete: autoComplete,
        type: "password",
        id: "passwordInput",
        placeholder: placeholder || 'Your password',
        onFocus: function onFocus() {
          _this2.setState({
            showTip: true
          });
        },
        onBlur: function onBlur() {
          _this2.setState({
            showTip: false
          });
        },
        isInvalid: this.state.touched && this._invalid()
      }));
    }
  }, {
    key: "_invalid",
    value: function _invalid() {
      return this.state.tooltipValidation.filter(function (v) {
        return !v.valid;
      }).length > 0;
    }
  }, {
    key: "_getTooltipNode",
    value: function _getTooltipNode() {
      if (!this.state.showTip) return;
      var validation = this.state.tooltipValidation;
      var validationNodes = validation.map(function (_ref) {
        var valid = _ref.valid,
          message = _ref.message;
        var iconName = valid ? _freeSolidSvgIcons.faCheck : _freeSolidSvgIcons.faTimes;
        var iconColor = valid ? 'green' : 'red';
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "icon-spacer"
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: iconName,
          style: {
            color: iconColor
          }
        }), ' '), message);
      });
      return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
        placement: "top",
        isOpen: this.state.showTip,
        target: "passwordInput",
        className: "in password-tooltip",
        id: "password-tooltip"
      }, "Passwords must contain:", validationNodes);
    }
  }]);
}(_react.Component);
PasswordInput.propTypes = {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string
};